import React from 'react';
import { Config } from '@leverege/plugin';
import { Content, Text } from '@leverege/ui-elements';
import { PuffLoader } from 'react-spinners';

/**
 * Returns a loading screen.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LoadingScreen(props) {
  const Loader = Config.get('LoadingScreen', 'spinner', PuffLoader);
  const loaderProps = Config.get('LoadingScreen', 'props', {});
  const {
    variant = 'loadingScreen',
    size = loaderProps.size || 30,
    color,
    title,
    children,
    subchildren
  } = props;
  return /*#__PURE__*/_jsx(Content, {
    children: /*#__PURE__*/_jsxs(Content.Area, {
      variant: variant,
      layout: `flex:${variant}`,
      children: [children, /*#__PURE__*/_jsx(Loader, {
        size: size,
        color: color || 'var( --color-loader, var( --color-brand200, #dedede ) )'
      }), title && /*#__PURE__*/_jsx(Text, {
        variant: "loadingScreen|subTitle",
        children: title
      }), subchildren]
    })
  });
}